<template>
  <div>
      <v-chip v-if="fareFeatures"
        v-for="(feature, index) in fareFeatures.features"
        :key="index"
        justify-center
        style="text-align: center; padding: 6px"
      >
        {{ feature }}
      </v-chip>
</div>
</template>

<script>
export default {
  name: "THYFareFeatures",
  props: {
    fareName: {
      type: String,
      required: true,
    },
    flightType: {
      type: String,
      default: "domestic", // domestic, international
    },
  },
  data() {
    return {
      thyFares: {
        "Eco Fly": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "15 kg Uçak Altı Bagajı",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "20-30 kg Uçak Altı Bagajı (Rotaya Göre Değişir)",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
        },
        "Extra Fly": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "20 kg Uçak Altı Bagajı",
              "Ücretsiz Standart Koltuk Seçimi",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "20-30 kg Uçak Altı Bagajı (Rotaya Göre Değişir)",
              "Ücretsiz Standart Koltuk Seçimi",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
        },
        "Prime Fly": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "25 kg Uçak Altı Bagajı",
              "Ücretsiz Standart Koltuk Seçimi",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "20-30 kg Uçak Altı Bagajı (Rotaya Göre Değişir)",
              "Ücretsiz Standart Koltuk Seçimi",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
        },
        "Flex Fly":{
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "30 kg Uçak Altı Bagajı",
              "Esnek Değişim ve İade Hakkı",
              "Ücretsiz Standart Koltuk Seçimi",
              "Ekonomi Sınıfı Standart Hizmetler",
            ],
          },
        },
        "Business": {
          domestic: {
            features: [
              "2 Adet Kabin Bagajı (55x40x23 cm, Toplam 16 kg)",
              "30 kg Uçak Altı Bagajı",
              "Business Class Koltuk ve Hizmetler",
              "Business Lounge Erişimi",
              "Öncelikli Check-in ve Boarding",
            ],
          },
          international: {
            features: [
              "2 Adet Kabin Bagajı (55x40x23 cm, Toplam 16 kg)",
              "40 kg Uçak Altı Bagajı (2x32 kg veya 2x23 kg)",
              "Business Class Koltuk ve Hizmetler",
              "Business Lounge Erişimi",
              "Öncelikli Check-in ve Boarding",
            ],
          },
        },
        "Business": {
          domestic: {
            features: [
              "2 Adet Kabin Bagajı (55x40x23 cm, Toplam 16 kg)",
              "30 kg Uçak Altı Bagajı",
              "Business Class Koltuk ve Hizmetler",
              "Business Lounge Erişimi",
              "Öncelikli Check-in ve Boarding",
              "Esnek Değişim ve İade Hakkı",
            ],
          },
          international: {
            features: [
              "2 Adet Kabin Bagajı (55x40x23 cm, Toplam 16 kg)",
              "40 kg Uçak Altı Bagajı (2x32 kg veya 2x23 kg)",
              "Business Class Koltuk ve Hizmetler",
              "Business Lounge Erişimi",
              "Öncelikli Check-in ve Boarding",
              "Esnek Değişim ve İade Hakkı",
            ],
          },
        },
      },
    };
  },
  computed: {
    fareFeatures() {
      console.log
      const normalizedFareName = this.fareName
        ? this.fareName
        : '';

      if (!normalizedFareName || !this.thyFares[normalizedFareName]) {
        return null;
      }

      const fare = this.thyFares[normalizedFareName];

      // Check if flight type specific data exists
      if (fare[this.flightType]) {
        return fare[this.flightType];
      }

      // Fallback to domestic if no specific type found
      return fare.domestic || fare.international || null;
    },
  },
};
</script>

<style scoped>
</style>
